import type { JsonObject } from "../specsModel/utils";

export type { JsonObject } from "../specsModel/utils";

export function readObject(value: unknown): JsonObject {
  return value !== null && typeof value === "object" && !Array.isArray(value)
    ? (value as JsonObject)
    : {};
}

export function readArray(value: unknown): unknown[] {
  return Array.isArray(value) ? value : [];
}

export function readObjectArray(value: unknown): JsonObject[] {
  return readArray(value).map((entry) => readObject(entry));
}
